export const sort_map = {
    "Featured": "featured",
    "Name A-Z": "name_asc",
    "Name Z-A": "name_desc",
    "Price - Low to High": "price_low",
    "Price - High to Low": "price_high",
}